import React, { useState } from "react";
import { setTrackingUser, setState } from "../rosbridge_client";

function SetupScreen({ onNext }) {
  const [username, setUsername] = useState("");

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Temi Control Panel 🤖</h1>

      {/* Box per inserire il nome + pulsante Send affiancato */}
      <div style={styles.inputBox}>
        <input
          type="text"
          placeholder="Enter Name"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          style={styles.input}
        />
        <button
          onClick={() => setTrackingUser(username)}
          style={styles.sendButton}
        >
          Send
        </button>
      </div>

      {/* Pulsante Start Patrolling */}
      <button
        onClick={() => setState("FINDING")}
        style={{ ...styles.button, backgroundColor: "#28a745", marginTop: "30px" }}
      >
        Start Patrolling 🚶
      </button>

      {/* Vai a Family Memories */}
      <button
        onClick={onNext}
        style={{ ...styles.button, marginTop: "20px", backgroundColor: "#007bff" }}
      >
        Go to Family Memories 📸
      </button>
    </div>
  );
}

//
// 🎨 STILI
//
const styles = {
  container: {
    backgroundColor: "#f9f9f9",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  title: { color: "#333", marginBottom: "20px" },
  inputBox: {
    display: "flex",
    flexDirection: "row", // 👈 cambia da column a row
    alignItems: "center",
    gap: "10px",           // spazio tra input e bottone
    marginTop: "10px",
  },
  input: {
    padding: "10px",
    fontSize: "16px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    width: "200px",
    textAlign: "center",
  },
  sendButton: {
    padding: "10px 20px",
    fontSize: "16px",
    borderRadius: "8px",
    border: "none",
    backgroundColor: "#007bff",
    color: "white",
    cursor: "pointer",
  },
  button: {
    padding: "12px 24px",
    fontSize: "16px",
    borderRadius: "8px",
    border: "none",
    color: "white",
    cursor: "pointer",
  },
};

export default SetupScreen;
